module.exports = __webpack_public_path__ + "static/img/lijunfeng.8750822.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/haibao_h5/lijunfeng.jpg
// module id = mR3O
// module chunks = 0